// @flow

import * as React from 'react';
import { Flex, Box } from 'react-system';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { useTheme } from '../../../theme';
import { createDescriptor } from '../../../controls/router';
import type { AggregatesListingsFilters_root } from '../__generated__/AggregatesListingsFilters_root.graphql.js';
import { pageDescriptor, portalFilterDescriptor } from './sharedDescriptors';

type Props = {|
  root: AggregatesListingsFilters_root,
  inline?: boolean,
  shouldFlush: boolean,
|};

const combinedFilterDescriptor = createDescriptor(
  portalFilterDescriptor,
  pageDescriptor,
);

export const Portals = (props: Props): React.Node => {
  const { text } = useTheme();

  const portals = props.root.aggregatesListingInfo.portals;
  const [
    configFilters,
    setConfigFilters,
    flushConfigFilters,
  ] = combinedFilterDescriptor.useState();

  const flush = () => {
    setConfigFilters({ page: 0 });
    if (props.shouldFlush) {
      flushConfigFilters();
    }
  };

  const checkboxes: Array<{|
    id: string,
    title: string,
    checked: boolean,
  |}> = portals.map(portal => ({
    id: portal.id,
    title: portal.title,
    checked: configFilters.portal_in.includes(portal.id),
  }));

  const onClick = ch => {
    const newChecks = checkboxes.map(nch => ({
      ...nch,
      checked: nch.id === ch.id ? !nch.checked : nch.checked,
    }));

    setConfigFilters({
      portal_in: newChecks
        .filter(nch => nch.checked === true)
        .map(nch => nch.id),
    });

    flush();
  };

  return (
    <Flex p={3} pb={0} flexWrap="wrap">
      {checkboxes.map(ch => (
        <Box key={ch.title} width={[1, 1 / 2]}>
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                checked={ch.checked}
                onChange={() => {
                  onClick(ch);
                }}
              />
            }
            label={<Box css={text.subtitle2}>{ch.title}</Box>}
          />
        </Box>
      ))}
    </Flex>
  );
};
